module.exports = __webpack_public_path__ + "img/2.8eb6bae5.jpg";